import _classCallCheck from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _isNativeReflectConstruct from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct";
import _getPrototypeOf from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createForOfIteratorHelper from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import * as e from "react";
import t, { createContext as r, Component as n, useState as o, useEffect as i, useContext as s } from "react";
import { initialize as a } from "launchdarkly-js-client-sdk";
export * from "launchdarkly-js-client-sdk";
import l from "lodash.camelcase";
import c from "hoist-non-react-statics";
var p = {
    useCamelCaseFlagKeys: !0,
    sendEventsOnFlagRead: !0
  },
  u = r({
    flags: {},
    flagKeyMap: {},
    ldClient: void 0
  }),
  f = u.Provider,
  d = u.Consumer,
  y = function y(e) {
    var t;
    return null != (t = e.context) ? t : e.user;
  },
  h = function h(e) {
    var t = {};
    for (var _r in e) 0 !== _r.indexOf("$") && (t[l(_r)] = e[_r]);
    return t;
  },
  g = function g(e, t) {
    var r = {};
    for (var _n in e) t && void 0 === t[_n] || (r[_n] = e[_n].current);
    return r;
  },
  O = function O(e, t) {
    var r = e.allFlags();
    return t ? Object.keys(t).reduce(function (e, n) {
      return e[n] = Object.prototype.hasOwnProperty.call(r, n) ? r[n] : t[n], e;
    }, {}) : r;
  };
function b(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : p;
  var n = arguments.length > 3 ? arguments[3] : undefined;
  var o = function (e, t) {
      if (void 0 === t) return e;
      return Object.keys(t).reduce(function (t, r) {
        return m(e, r) && (t[r] = e[r]), t;
      }, {});
    }(t, n),
    _r$useCamelCaseFlagKe = r.useCamelCaseFlagKeys,
    i = _r$useCamelCaseFlagKe === void 0 ? !0 : _r$useCamelCaseFlagKe,
    _ref = i ? function (e) {
      var t = {},
        r = {};
      for (var _n2 in e) {
        if (0 === _n2.indexOf("$")) continue;
        var _o = l(_n2);
        t[_o] = e[_n2], r[_o] = _n2;
      }
      return [t, r];
    }(o) : [o],
    _ref2 = _slicedToArray(_ref, 2),
    s = _ref2[0],
    _ref2$ = _ref2[1],
    a = _ref2$ === void 0 ? {} : _ref2$;
  return {
    flags: r.sendEventsOnFlagRead ? v(e, s, a, i) : s,
    flagKeyMap: a
  };
}
function m(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function v(e, t, r, n) {
  return new Proxy(t, {
    get: function get(t, o, i) {
      var s = Reflect.get(t, o, i),
        a = n && m(r, o) || m(t, o);
      if ("symbol" == typeof o || !a) return s;
      if (void 0 === s) return;
      var l = n ? r[o] : o;
      return e.variation(l, s);
    }
  });
}
h.camelCaseKeys = h;
var j = {
  wrapperName: "react-client-sdk",
  wrapperVersion: "3.4.0",
  sendEventsOnlyForVariation: !0
};
var w = Object.defineProperty,
  C = Object.defineProperties,
  P = Object.getOwnPropertyDescriptors,
  x = Object.getOwnPropertySymbols,
  F = Object.prototype.hasOwnProperty,
  E = Object.prototype.propertyIsEnumerable,
  S = function S(e, t, r) {
    return t in e ? w(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: r
    }) : e[t] = r;
  },
  k = function k(e, t) {
    for (var r in t || (t = {})) F.call(t, r) && S(e, r, t[r]);
    if (x) {
      var _iterator = _createForOfIteratorHelper(x(t)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var r = _step.value;
          E.call(t, r) && S(e, r, t[r]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return e;
  },
  D = function D(e, t) {
    return C(e, P(t));
  },
  I = function I(e, t, r) {
    return new Promise(function (n, o) {
      var i = function i(e) {
          try {
            a(r.next(e));
          } catch (e) {
            o(e);
          }
        },
        s = function s(e) {
          try {
            a(r.throw(e));
          } catch (e) {
            o(e);
          }
        },
        a = function a(e) {
          return e.done ? n(e.value) : Promise.resolve(e.value).then(i, s);
        };
      a((r = r.apply(e, t)).next());
    });
  };
var K = /*#__PURE__*/function (_n3) {
  function K(e) {
    var _this;
    _classCallCheck(this, K);
    _this = _callSuper(this, K, [e]), _this.getReactOptions = function () {
      return k(k({}, p), _this.props.reactOptions);
    }, _this.subscribeToChanges = function (e) {
      var t = _this.props.flags;
      e.on("change", function (r) {
        var n = _this.getReactOptions(),
          o = g(r, t),
          i = k(k({}, _this.state.unproxiedFlags), o);
        Object.keys(o).length > 0 && _this.setState(function (r) {
          return k(D(k({}, r), {
            unproxiedFlags: i
          }), b(e, i, n, t));
        });
      });
    }, _this.onFailed = function (e, t) {
      _this.setState(function (e) {
        return D(k({}, e), {
          error: t
        });
      });
    }, _this.onReady = function (e, t, r) {
      var n = O(e, r);
      _this.setState(function (o) {
        return k(D(k({}, o), {
          unproxiedFlags: n
        }), b(e, n, t, r));
      });
    }, _this.prepareLDClient = function () {
      return I(_assertThisInitialized(_this), null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var e, _this$props, t, r, n, o, i, s, l, _c;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, t = _this$props.clientSideID, r = _this$props.flags, n = _this$props.options;
              _context.next = 3;
              return this.props.ldClient;
            case 3:
              o = _context.sent;
              i = this.getReactOptions();
              l = this.state.unproxiedFlags;
              if (!o) {
                _context.next = 10;
                break;
              }
              l = O(o, r);
              _context.next = 21;
              break;
            case 10:
              _c = null != (e = y(this.props)) ? e : {
                anonymous: !0,
                kind: "user"
              };
              o = a(t, _c, k(k({}, j), n));
              _context.prev = 12;
              _context.next = 15;
              return o.waitForInitialization(this.props.timeout);
            case 15:
              l = O(o, r);
              _context.next = 21;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](12);
              s = _context.t0, (null == s ? void 0 : s.name.toLowerCase().includes("timeout")) && (o.on("failed", this.onFailed), o.on("ready", function () {
                _this2.onReady(o, i, r);
              }));
            case 21:
              this.setState(function (e) {
                return D(k(D(k({}, e), {
                  unproxiedFlags: l
                }), b(o, l, i, r)), {
                  ldClient: o,
                  error: s
                });
              }), this.subscribeToChanges(o);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[12, 18]]);
      }));
    };
    var t = e.options;
    if (_this.state = {
      flags: {},
      unproxiedFlags: {},
      flagKeyMap: {}
    }, t) {
      var _e = t.bootstrap;
      if (_e && "localStorage" !== _e) {
        var _this$getReactOptions = _this.getReactOptions(),
          _t = _this$getReactOptions.useCamelCaseFlagKeys;
        _this.state = {
          flags: _t ? h(_e) : _e,
          unproxiedFlags: _e,
          flagKeyMap: {}
        };
      }
    }
    return _this;
  }
  _inherits(K, _n3);
  return _createClass(K, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      return I(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var e;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              e = this.props.deferInitialization;
              _context2.t0 = e && !y(this.props);
              if (_context2.t0) {
                _context2.next = 5;
                break;
              }
              _context2.next = 5;
              return this.prepareLDClient();
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      return I(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var t, r;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              t = this.props.deferInitialization, r = !y(e) && y(this.props);
              _context3.t0 = t && r;
              if (!_context3.t0) {
                _context3.next = 5;
                break;
              }
              _context3.next = 5;
              return this.prepareLDClient();
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        e = _this$state.flags,
        r = _this$state.flagKeyMap,
        n = _this$state.ldClient,
        o = _this$state.error;
      return t.createElement(f, {
        value: {
          flags: e,
          flagKeyMap: r,
          ldClient: n,
          error: o
        }
      }, this.props.children);
    }
  }]);
}(n);
var R = Object.defineProperty,
  M = Object.defineProperties,
  L = Object.getOwnPropertyDescriptors,
  z = Object.getOwnPropertySymbols,
  T = Object.prototype.hasOwnProperty,
  V = Object.prototype.propertyIsEnumerable,
  $ = function $(e, t, r) {
    return t in e ? R(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: r
    }) : e[t] = r;
  },
  N = function N(e, t) {
    for (var r in t || (t = {})) T.call(t, r) && $(e, r, t[r]);
    if (z) {
      var _iterator2 = _createForOfIteratorHelper(z(t)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var r = _step2.value;
          V.call(t, r) && $(e, r, t[r]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    return e;
  };
function U(t) {
  return function (r) {
    var n = t.reactOptions,
      o = N(N({}, p), n),
      i = (s = N({}, t), M(s, L({
        reactOptions: o
      })));
    var s;
    function a(t) {
      return e.createElement(K, N({}, i), e.createElement(r, N({}, t)));
    }
    return c(a, r), a;
  };
}
var q = Object.defineProperty,
  A = Object.defineProperties,
  B = Object.getOwnPropertyDescriptors,
  G = Object.getOwnPropertySymbols,
  H = Object.prototype.hasOwnProperty,
  J = Object.prototype.propertyIsEnumerable,
  Q = function Q(e, t, r) {
    return t in e ? q(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: r
    }) : e[t] = r;
  },
  W = function W(e, t) {
    for (var r in t || (t = {})) H.call(t, r) && Q(e, r, t[r]);
    if (G) {
      var _iterator3 = _createForOfIteratorHelper(G(t)),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var r = _step3.value;
          J.call(t, r) && Q(e, r, t[r]);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    return e;
  },
  X = function X(e, t) {
    return A(e, B(t));
  };
function Y(e) {
  return r = this, n = null, s = /*#__PURE__*/_regeneratorRuntime().mark(function s() {
    var r, n, s, l, c, u, d, h, m, v, w, C;
    return _regeneratorRuntime().wrap(function s$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          s = e.clientSideID, l = e.flags, c = e.options, u = e.reactOptions, d = W(W({}, p), u), h = null != (r = y(e)) ? r : {
            anonymous: !0,
            kind: "user"
          };
          v = {};
          _context4.next = 4;
          return e.ldClient;
        case 4:
          _context4.t0 = n = _context4.sent;
          if (!(null != _context4.t0)) {
            _context4.next = 9;
            break;
          }
          _context4.t1 = n;
          _context4.next = 10;
          break;
        case 9:
          _context4.t1 = a(s, h, W(W({}, j), c));
        case 10:
          w = _context4.t1;
          _context4.prev = 11;
          _context4.next = 14;
          return w.waitForInitialization(e.timeout);
        case 14:
          v = O(w, l);
          _context4.next = 20;
          break;
        case 17:
          _context4.prev = 17;
          _context4.t2 = _context4["catch"](11);
          m = _context4.t2;
        case 20:
          C = (null == c ? void 0 : c.bootstrap) && "localStorage" !== c.bootstrap ? c.bootstrap : v;
          return _context4.abrupt("return", function (_ref3) {
            var e = _ref3.children;
            var _o2 = o(function () {
                return X(W({
                  unproxiedFlags: C
                }, b(w, C, d, l)), {
                  ldClient: w,
                  error: m
                });
              }),
              _o3 = _slicedToArray(_o2, 2),
              r = _o3[0],
              n = _o3[1];
            i(function () {
              function e(e) {
                var t = g(e, l);
                Object.keys(t).length > 0 && n(function (e) {
                  var r = W(W({}, e.unproxiedFlags), t);
                  return W(X(W({}, e), {
                    unproxiedFlags: r
                  }), b(w, r, d, l));
                });
              }
              function t() {
                var e = O(w, l);
                n(function (t) {
                  return W(X(W({}, t), {
                    unproxiedFlags: e
                  }), b(w, e, d, l));
                });
              }
              function r(e) {
                n(function (t) {
                  return X(W({}, t), {
                    error: e
                  });
                });
              }
              return w.on("change", e), (null == m ? void 0 : m.name.toLowerCase().includes("timeout")) && (w.on("failed", r), w.on("ready", t)), function () {
                w.off("change", e), w.off("failed", r), w.off("ready", t);
              };
            }, []);
            var s = function (e, t) {
              var r = {};
              for (var n in e) H.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
              if (null != e && G) {
                var _iterator4 = _createForOfIteratorHelper(G(e)),
                  _step4;
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var n = _step4.value;
                    t.indexOf(n) < 0 && J.call(e, n) && (r[n] = e[n]);
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
              }
              return r;
            }(r, ["unproxiedFlags"]);
            return t.createElement(f, {
              value: s
            }, e);
          });
        case 22:
        case "end":
          return _context4.stop();
      }
    }, s, null, [[11, 17]]);
  }), new Promise(function (e, t) {
    var o = function o(e) {
        try {
          a(s.next(e));
        } catch (e) {
          t(e);
        }
      },
      i = function i(e) {
        try {
          a(s.throw(e));
        } catch (e) {
          t(e);
        }
      },
      a = function a(t) {
        return t.done ? e(t.value) : Promise.resolve(t.value).then(o, i);
      };
    a((s = s.apply(r, n)).next());
  });
  var r, n, s;
}
var Z = Object.defineProperty,
  _ = Object.getOwnPropertySymbols,
  ee = Object.prototype.hasOwnProperty,
  te = Object.prototype.propertyIsEnumerable,
  re = function re(e, t, r) {
    return t in e ? Z(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: r
    }) : e[t] = r;
  },
  ne = function ne(e, t) {
    for (var r in t || (t = {})) ee.call(t, r) && re(e, r, t[r]);
    if (_) {
      var _iterator5 = _createForOfIteratorHelper(_(t)),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var r = _step5.value;
          te.call(t, r) && re(e, r, t[r]);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
    return e;
  };
function oe() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    clientOnly: !1
  };
  return function (r) {
    return function (n) {
      return e.createElement(d, null, function (_ref4) {
        var o = _ref4.flags,
          i = _ref4.ldClient;
        return t.clientOnly ? e.createElement(r, ne({
          ldClient: i
        }, n)) : e.createElement(r, ne({
          flags: o,
          ldClient: i
        }, n));
      });
    };
  };
}
var ie = function ie() {
    var _s = s(u),
      e = _s.flags;
    return e;
  },
  se = function se() {
    var _s2 = s(u),
      e = _s2.ldClient;
    return e;
  };
function ae() {
  var _s3 = s(u),
    e = _s3.error;
  return e;
}
export { K as LDProvider, Y as asyncWithLDProvider, h as camelCaseKeys, p as defaultReactOptions, ie as useFlags, se as useLDClient, ae as useLDClientError, oe as withLDConsumer, U as withLDProvider };